<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.addVisitorArea')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm>



                                <CRow>
                                  <CCol sm="6" md="4">                                        <treeselect
                                                v-model="document_person"

                                                :async="true"
                                                :load-options="load_persons"
                                                :placeholder="$t('components.searchUser')"
                                                :normalizer="normalizer_persons"
                                        />

                                    </CCol>
                                </CRow>
<br>

                          <CRow>
                            <CCol >
                              <CSelect
                                  :label="$t('components.province')"
                                  horizontal
                                  :options="province_items"
                                  :value.sync="selected_province"/>

                            </CCol>
                            <CCol >
                              <CSelect
                                  :label="$t('components.city')"
                                  horizontal
                                  :options="city_items"
                                  :value.sync="selected_city"/>

                            </CCol>
                            <CCol >
                              <CSelect
                                  :label="$t('components.area')"
                                  horizontal
                                  :options="area_items"
                                  :value.sync="selected_area"/>


                            </CCol>

                          </CRow>



                        </CForm>
                    </CCardBody>
                    <CCardFooter>
                        <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm" color="primary">
                            <CIcon name="cil-check-circle"/>
                          {{$t('buttons.addArea')}}
                        </CButton>
                        <CButton v-if="status_form==0" @click="emptyList()" type="reset" size="sm" color="danger">
                            <CIcon name="cil-ban"/>
                          {{$t('buttons.emptyForm')}}

                        </CButton>
                        <CButton v-if="status_form!=0" @click="emptyList()" type="reset" size="sm" color="danger">
                            <CIcon name="cil-ban"/>
                            {{$t("buttons.cancel")}}
                        </CButton>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.areaList')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                :items="items"
                                :fields="fields"

                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <p >{{item.row_id+1}}</p>

                                </td>

                            </template>
                            <template #visitor="{item}">

                                <td>
                                    <p >{{item.personName}}</p>

                                </td>

                            </template>


                            <template #area="{item}">

                                <td>
                                    <p >{{item.areaTitle}}</p>

                                </td>

                            </template>


                            <template #operation="{item}">
                                <td>
                                  <CButton class="m-1"
                                           color="danger"
                                           variant="outline"
                                           :title="$t('buttons.delete')"
                                           square
                                           size="sm"
                                           @click="delete_item_dialog(item)"
                                  ><CIcon name="cilTrash" /></CButton>
                                </td>
                            </template>


                        </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items = [];

    export default {
        name: 'Login',
        components: {
            Treeselect,

        },
        data() {
            return {

                validate_errors: [],
                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                fields : [
                    {key: 'row',label:this.$t('tables.row'), _style: 'width:10%'},
                    {key: 'visitor',label:this.$t('tables.visitor'), _style: 'width:10%'},
                    {key: 'area',label:this.$t('tables.area'), _style: 'width:10%'},
                    {key: 'operation',label:this.$t('tables.operation'), _style: 'width:20%;'},


                ],

                province_items: [

                ],
                selected_province: 0,

                city_items: [

                ],
                selected_city: 0,
                area_items: [

                ],
                selected_area: 0,

                document_person: null,

                details: [],
                collapseDuration: 0,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros:true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {
                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },

            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];


            this.get_lists();
            this.get_provinces();
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'selected_province': function () {
                console.log("peovince changed");
                this.get_cities();
            },
            'selected_city': function () {
                this.get_areas();
            }
        },
        methods: {
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.document_person != '' && this.selected_area != 0) {
                    return true;
                }


                if (this.document_person == '') {
                    this.$root.root_validate_errors.push(this.$t('dialogs.selectUser'));
                }
                if (this.selected_area == 0) {
                    this.$root.root_validate_errors.push(this.$t('dialogs.selectArea'));
                }

                return false;
                // e.preventDefault();
            },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.areaName;
                this.selected_province = item.provinceId;
                this.selected_city = item.cityId;
                this.get_cities();
                this.polygon_area = JSON.parse(item.areaRange);
                this.show_polygon();

                this.status_form = item.id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);


                axios.post('GetVisitorAreas', formData, {
                    params: {
                        // isparent : self.$route.params.cat_id
                    },
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        })
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goSubCategories(item, index) {

                this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            get_provinces() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);


                axios.post('GetStateList', formData, {
                    params: {
                        // isparent : self.$route.params.cat_id
                    },
                    headers: {
                        Authorization: 'Bearer ' + localStorage.getItem('token')
                    }
                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                      self.province_items=[]

                        self.province_items = self.sort_array(
                            self.province_items, content_data.data,
                            'id','provinceName');



                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_cities() {
                var self = this;

                const formData = new FormData();


                formData.append('id', this.selected_province);

                axios.post('GetCityListByStateId', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
                        //         fields;
                      self.city_items=[]
                        self.city_items = self.sort_array(
                            self.city_items, content_data.data,
                            'cityId','cityName');


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_areas() {
                var self = this;
                const formData = new FormData();

                formData.append('id', this.selected_city);

                axios.post('GetAreaTitlesByCityId', formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.area_items = [];
                      content_data.data.forEach((val) => {
                        var obj = {label: val.areaName, value: val.id}

                        self.area_items.push(obj);
                      });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            insert_data() {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddVisitorArea";
                } else {
                    url = "EditAreaTitle";
                    formData.append('id', this.status_form)

                }


                formData.append('PersonId', this.document_person);
                formData.append('AreaId', this.selected_area);
                axios.post(url, formData, {}).then((res) => {



                    self.status_form = 0;
                    self.name = '';
                    self.color = '';
                    self.description = '';
                    self.previewImage = '';
                    self.get_lists();

                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

                this.status_form = item.id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteVisitorArea";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
